// src/helpers/Date.js

export const MONTHS = {
  0: "janvier",
  1: "février",
  2: "mars",
  3: "avril",
  4: "mai",
  5: "juin",
  6: "juillet",
  7: "août",
  8: "septembre",
  9: "octobre",
  10: "novembre",
  11: "décembre",
};

/**
 * Renvoie le mois en toutes lettres en français, à partir d'un objet Date.
 * @param {Date} date
 * @returns {string} nom du mois en français
 */
export const getMonth = (date) => MONTHS[date.getMonth()];
